<template>
    <v-select
        dense
        outlined
        hide-details
        background-color="white"
        clearable
        :items="items"
        :placeholder="$t('context')"
        v-bind="$attrs"
        v-on="$listeners"
    >
    </v-select>
</template>

<script>
import { CONTEXT as BannerContext } from '@/models/Banner';

export default {
    name: 'BannerTypeSelect',
    created() {
        this.items = Object.entries(BannerContext).map((item) => {
            return {
                value: item[0],
                text: this.$t(item[1].title_key),
            };
        });
    },
};
</script>
